// the activity keys MUST be a 1-1 mapping with the corresponding Ruby file
//   if a corresponding profile notification exists, it's recommended that the suffix and constant naming is equal
//     this enables tracking reads of correspoonding notifications and visualizing these for other profile types
import { ROUTES_EMPLOYEES } from '@/app/data/route_constants';

export const ACTIVITIES_PROJECTS = {
  ANNOUNCEMENT_CREATE: 'activity.projects.announcement.create',
  BUILDING_CREATE: 'activity.projects.building.create',
  DOCUMENT_CREATE: 'activity.projects.document.create',
  LOT_CREATE: 'activity.projects.lot.create',
  PHASE_CREATE: 'activity.projects.phase.create',
  QUESTION_CREATE: 'activity.projects.question.create',
  SPACE_CREATE: 'activity.projects.space.create',
  SPACE_UPDATE: 'activity.projects.space.update',
  SURVEY_TYPE_CREATE: 'activity.projects.survey_type.create',
  TICKET_CREATE: 'activity.projects.ticket.create',
  UNIT_ASSIGN: 'activity.projects.unit.assign',
  UNIT_CREATE: 'activity.projects.unit.create',
  UNIT_INVISIBLED: 'activity.projects.unit.invisibled',
  UNIT_UNASSIGN: 'activity.projects.unit.unassign',
  UNIT_VISIBLED: 'activity.projects.unit.visibled',
};

export const ACTIVITIES_UNITS = {
  ANNOUNCEMENT_CREATE: 'activity.units.announcement.create',
  DECISION_CREATE: 'activity.units.decision.create',
  DECISION_DOCUMENT_CREATE: 'activity.units.decision_document.create',
  DECISION_PROPOSAL_APPROVED: 'activity.units.decision_proposal.approved',
  DECISION_PROPOSAL_CREATE: 'activity.units.decision_proposal.create',
  DECISION_PROPOSAL_UNAPPROVED: 'activity.units.decision_proposal.unapproved',
  DECISION_PUBLISHED_CUSTOMER: 'activity.units.decision.published.customer',
  DECISION_PUBLISHED_PARTNERS: 'activity.units.decision.published.partners',
  DECISION_RELAUNCHED: 'activity.units.decision.relaunched',
  DECISION_NOT_INTERESTED: 'activity.units.decision.not_interested',
  DOCUMENT_CREATE: 'activity.units.document.create',
  ISSUE_APPROVAL_CREATE: 'activity.units.issue.approval.create',
  ISSUE_APPROVAL_DELETE: 'activity.units.issue.approval.delete',
  ISSUE_APPROVED: 'activity.units.issue.approved',
  ISSUE_CREATE: 'activity.units.issue.create',
  ISSUE_REJECTED: 'activity.units.issue.approval.rejected',
  ISSUE_STATUS_UPDATE: 'activity.units.issue.status.update',
  PROPOSAL_DELETED: 'activity.units.proposal.deleted',
  QUESTION_CREATE: 'activity.units.question.create',
  SPACE_UPDATE: 'activity.units.space.update',
  SURVEY_CREATE: 'activity.units.survey.create',
  SURVEY_PUBLISHED: 'activity.units.survey.published',
  TICKET_CREATE: 'activity.units.ticket.create',
  TICKET_MESSAGE_MOVE: 'activity.units.ticket.message.move',
  UNIT_ASSIGN: 'activity.units.unit.assign',
  UNIT_INVISIBLED: 'activity.units.unit.invisibled',
  UNIT_UNASSIGN: 'activity.units.unit.unassign',
  UNIT_VISIBLED: 'activity.units.unit.visibled',
};

export const ACTIVITIES_WITH_SEEN_BY = new Set([
  ACTIVITIES_PROJECTS.ANNOUNCEMENT_CREATE,
  ACTIVITIES_PROJECTS.DOCUMENT_CREATE,
  ACTIVITIES_PROJECTS.QUESTION_CREATE,
  ACTIVITIES_PROJECTS.TICKET_CREATE,
  ACTIVITIES_UNITS.ANNOUNCEMENT_CREATE,
  ACTIVITIES_UNITS.DECISION_DOCUMENT_CREATE,
  ACTIVITIES_UNITS.DECISION_PROPOSAL_APPROVED,
  ACTIVITIES_UNITS.DECISION_PROPOSAL_CREATE,
  ACTIVITIES_UNITS.DECISION_PUBLISHED_CUSTOMER,
  ACTIVITIES_UNITS.DOCUMENT_CREATE,
  ACTIVITIES_UNITS.QUESTION_CREATE,
  ACTIVITIES_UNITS.TICKET_CREATE,
]);

export const ACTIVITIES_PROJECTS_TO_ROUTES = {
  [ACTIVITIES_PROJECTS.ANNOUNCEMENT_CREATE]: ROUTES_EMPLOYEES.PROJECT_ANNOUNCEMENTS,
  [ACTIVITIES_PROJECTS.BUILDING_CREATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.DOCUMENT_CREATE]: ROUTES_EMPLOYEES.PROJECT_DOCUMENTS,
  [ACTIVITIES_PROJECTS.LOT_CREATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.PHASE_CREATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.QUESTION_CREATE]: ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS_SHOW,
  [ACTIVITIES_PROJECTS.SPACE_CREATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_SPACES,
  [ACTIVITIES_PROJECTS.SPACE_UPDATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_SPACES,
  [ACTIVITIES_PROJECTS.SURVEY_TYPE_CREATE]: ROUTES_EMPLOYEES.PROJECT_SURVEYS,
  [ACTIVITIES_PROJECTS.TICKET_CREATE]: ROUTES_EMPLOYEES.PROJECT_TICKETS_SHOW,
  [ACTIVITIES_PROJECTS.UNIT_ASSIGN]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_CREATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_INVISIBLED]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_UNASSIGN]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_VISIBLED]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
};

export const ACTIVITIES_UNITS_TO_ROUTES = {
  [ACTIVITIES_UNITS.ANNOUNCEMENT_CREATE]: ROUTES_EMPLOYEES.PROJECT_ANNOUNCEMENTS,
  [ACTIVITIES_UNITS.DECISION_CREATE]: ROUTES_EMPLOYEES.PROJECT_DECISION_TICKETS,
  [ACTIVITIES_UNITS.DECISION_DOCUMENT_CREATE]: ROUTES_EMPLOYEES.PROJECT_DECISION_DOCUMENTS,
  [ACTIVITIES_UNITS.DECISION_PROPOSAL_APPROVED]: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
  [ACTIVITIES_UNITS.DECISION_PROPOSAL_CREATE]: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
  [ACTIVITIES_UNITS.DECISION_PROPOSAL_UNAPPROVED]: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
  [ACTIVITIES_UNITS.DECISION_PUBLISHED_CUSTOMER]: ROUTES_EMPLOYEES.PROJECT_DECISION_TICKETS,
  [ACTIVITIES_UNITS.DECISION_PUBLISHED_PARTNERS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TICKETS,
  [ACTIVITIES_UNITS.DECISION_RELAUNCHED]: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
  [ACTIVITIES_UNITS.DECISION_NOT_INTERESTED]: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
  [ACTIVITIES_UNITS.DOCUMENT_CREATE]: ROUTES_EMPLOYEES.PROJECT_DOCUMENTS,
  [ACTIVITIES_UNITS.ISSUE_APPROVAL_CREATE]: ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_ISSUES,
  [ACTIVITIES_UNITS.ISSUE_APPROVAL_DELETE]: ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_ISSUES,
  [ACTIVITIES_UNITS.ISSUE_APPROVED]: ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_ISSUES,
  [ACTIVITIES_UNITS.ISSUE_REJECTED]: ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_ISSUES,
  [ACTIVITIES_UNITS.ISSUE_STATUS_UPDATE]: ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_ISSUES,
  [ACTIVITIES_UNITS.PROPOSAL_DELETED]: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
  [ACTIVITIES_UNITS.QUESTION_CREATE]: ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS_SHOW,
  [ACTIVITIES_UNITS.SPACE_UPDATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_SPACES,
  [ACTIVITIES_UNITS.SURVEY_CREATE]: ROUTES_EMPLOYEES.PROJECT_SURVEYS,
  [ACTIVITIES_UNITS.SURVEY_PUBLISHED]: ROUTES_EMPLOYEES.PROJECT_SURVEYS,
  [ACTIVITIES_UNITS.TICKET_CREATE]: ROUTES_EMPLOYEES.PROJECT_TICKETS_SHOW,
  [ACTIVITIES_UNITS.TICKET_MESSAGE_MOVE]: ROUTES_EMPLOYEES.PROJECT_TICKETS_SHOW,
  [ACTIVITIES_PROJECTS.UNIT_ASSIGN]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_CREATE]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_INVISIBLED]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_UNASSIGN]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  [ACTIVITIES_PROJECTS.UNIT_VISIBLED]: ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
};

export const ACTIVITIES_TO_ROUTES = {
  ...ACTIVITIES_PROJECTS_TO_ROUTES,
  ...ACTIVITIES_UNITS_TO_ROUTES,
};

export const ACTIVITIES_ICONS = [
  {
    notifiable_type: 'Document',
    icon: 'solid-file-lines',
  },
  {
    notifiable_type: 'Ticket',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Todo',
    icon: 'regular-square-check',
  },
  {
    notifiable_type: 'DecisionType',
    icon: 'regular-house-circle-check',
  },
  {
    notifiable_type: 'Decision',
    icon: 'regular-house-circle-check',
  },
  {
    notifiable_type: 'DecisionDocument',
    icon: 'regular-house-circle-check',
  },
  {
    notifiable_type: 'DecisionProposal',
    icon: 'regular-house-circle-check',
  },
  {
    notifiable_type: 'Proposal',
    icon: 'regular-house-circle-check',
  },
  {
    notifiable_type: 'Question',
    icon: 'solid-circle-question',
  },
  {
    notifiable_type: 'Announcement',
    icon: 'solid-bullhorn',
  },
  {
    notifiable_type: 'AnnouncementLevel',
    icon: 'solid-bullhorn',
  },
  {
    notifiable_type: 'Message',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Unit',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Building',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Lot',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Phase',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Project',
    icon: 'solid-comment',
  },
  {
    notifiable_type: 'Space',
    icon: 'solid-warehouse',
  },
  {
    notifiable_type: 'Survey',
    icon: 'solid-poll',
  },
  {
    notifiable_type: 'SurveyType',
    icon: 'solid-poll',
  },
  {
    notifiable_type: 'Reminder',
    icon: 'regular-bell',
  },
  {
    notifiable_type: 'Customer',
    icon: 'solid-users',
  },
  {
    notifiable_type: 'Employee',
    icon: 'solid-users',
  },
  {
    notifiable_type: 'Export',
    icon: 'solid-download',
  },
  {
    notifiable_type: 'Default',
    icon: 'regular-bell',
  },
  {
    notifiable_type: 'Issue',
    icon: 'regular-house-chimney-heart',
  },
  {
    notifiable_type: 'Installment',
    icon: 'regular-house-chimney-heart',
  },
];
